<template>
    <div class="Novedades">
        <header class="bg-dark text-light text-center py-3">
            <h1>¿Qué hay de nuevo en IPER?</h1>
            <img src="img/iconos/logo_color.png" class="img-fluid"/>
        </header>
        <main class="container features my-5">
            <template v-if="novedades.length > 0">
                <input type="text" v-model="buscar" class="form-control mb-3" placeholder="Buscar" />
                <div class="grid-container">
                    <div v-for="(novedad, index) of filtro" :key="index" style="text-align: left;">
                        <router-link :to="{ name: 'NovedadesConsultar', params: { id: novedad.id } }"
                            class="text-decoration-none text-dark">
                            <div class="cards shadow-sm animate__animated animate__fadeIn">
                                <h2>{{ novedad.titulo }}</h2>
                                <p>{{ novedad.descripcion }}</p>
                                <router-link :to="{ name: 'NovedadesConsultar', params: { id: novedad.id } }"
                                    class="text-primary fw-bold mb-3">
                                    Conoce más
                                </router-link>
                                <img :src="novedad.imagen" class="img-fluid" />
                            </div>
                        </router-link>
                    </div>
                </div>
                <div v-if="filtro.length === 0" class="text-center">
                    <h6>No se encontraron resultados</h6>
                </div>
            </template>
            <template v-else>
                <div class="text-center">
                    <h6>No se encontraron novedades</h6>
                </div>
            </template>
        </main>
    </div>
</template>

<script>
import { firebase, auth, db } from "../../firebase";
export default {
    name: "Novedades",

    data() {
        return {
            novedades: [],
            buscar: "",
            isLoading: false,
        }
    },

    computed: {
        filtro() {
            return this.novedades.filter(item => {
                return (
                    item.titulo.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    item.descripcion.toLowerCase().includes(this.buscar.toLowerCase())
                );
            });
        },
    },

    // mounted() {
    //     document.title = "Novedades - IPER"
    // },

    async created() {
        this.$isLoading(true);
        await this.obtenerNovedades();
    },

    methods: {
        async obtenerNovedades() {
            this.$isLoading(true);
            this.novedades = [];
            let arrayNovedades = [];
            db.collection("novedades").where("registro.estado", "in", ["Creado", "Editado"]).orderBy("registro.creacion", "asc")
                .onSnapshot((snapshot) => {
                snapshot.docChanges().forEach((change) => {
                    arrayNovedades = {
                        id: change.doc.id,
                        titulo: change.doc.data().titulo,
                        descripcion: change.doc.data().descripcion,
                        imagen: change.doc.data().secciones[0].imagen.url
                    }
                    if (change.type === "added") {
                        this.novedades.unshift(arrayNovedades);
                        this.$isLoading(false);
                    }
                    if (change.type === "modified") {
                        for (let index = 0; index < this.novedades.length; index++) {
                            if (change.doc.id == this.novedades[index].id) {
                                this.novedades.splice(index, 1, arrayNovedades);
                            }
                        }
                        this.$isLoading(false);
                    }
                    if (change.type === "removed") {
                        for (let index = 0; index < this.novedades.length; index++) {
                            if (change.doc.id == this.novedades[index].id) {
                                this.novedades.splice(index, 1);
                            }
                            
                        }
                        this.$isLoading(false);
                    }
                });
                let set = new Set(this.novedades.map(JSON.stringify));
                this.novedades = Array.from(set).map(JSON.parse);
                // console.log(this.novedades);
                this.$isLoading(false);
            }); 
        }
    }
}
</script>

<style scoped>
header img {
    margin-bottom: -45px;
    width: 40px;
}

.features {
    margin-bottom: 80px !important;
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    grid-gap: 20px;
    justify-items: center;
    align-items: stretch;
}

.cards {
    border: none;
    background-color: #E8E8E8;
    padding: 20px;
    border-radius: 15px;
    height: 100%;
    width: 100%;
    transition: transform 0.2s;
    cursor: pointer;
}

.card h2 {
    font-size: 1.25rem;
    margin-bottom: 1rem;
}

.card p {
    text-transform: none;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

.card img {
    border-radius: 15px;
}

.card:hover {
    transform: translateY(-5px);
}

@media screen and (max-width: 768px) {
    header img {
        margin-bottom: -45px;
        width: 60px;
    }

    .features {
        margin-bottom: 80px !important;
    }

    .grid-container {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        margin-bottom: 15px;
    }
}
</style>